module.exports = __webpack_public_path__ + "static/6-4064c19ac0500c00d5b4520f985fb100.png";